var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"term"},[_c('div',{staticClass:"title-term",domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('div',{staticClass:"output-term",domProps:{"innerHTML":_vm._s(_vm.output)}})])}
var staticRenderFns = []

export { render, staticRenderFns }